<template>
  <div class="filter" :class="{'hidden': !showFilter}">
    <div class="filter__header">
      <div class="filter__header-title acr-bold-18">Select filters</div>
      <!--<div class="filter-btn acr-bold projects-btn&#45;&#45;transparent" @click="$emit('close')">-->
        <!--&lt;!&ndash;<svgicon name="Close"></svgicon>&ndash;&gt;-->
      <!--</div>-->
      <!--<div class="filter-btn acr-bold" @click="$emit('clear')">-->
        <!--&lt;!&ndash;<svgicon name="Close"></svgicon>&ndash;&gt;-->
        <!--Clean-->
      <!--</div>-->
      <slot name="clear"></slot>
    </div>
    <div class="filter__sorting" v-if="showSorting">
      <div class="filter__subtitle acr-medium-18 acr-regular-18">Sorting</div>
      <el-select v-model="sorting" placeholder="Select">
        <el-option
          v-for="item in sortingOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div class="filter__types mb18" v-if="showType">
      <div class="filter__subtitle acr-medium-18 acr-regular-18">Type of analysis</div>
      <div>
        <el-checkbox v-model="brandDetectionOnly"><span class="acr-medium">Brand detection</span></el-checkbox>
        <el-checkbox v-model="videoAnalyticOnly"><span class="acr-medium">Video analytics</span></el-checkbox>
      </div>
    </div>
    <BaseScrollbar>

    <div class="filter__columns" :class="{'one-column': oneColumn}">
        <slot></slot>
    </div>
    </BaseScrollbar>
    <slot name="clear"></slot>

  </div>
</template>

<script>
import BaseScrollbar from './BaseScrollbar';

export default {
  name: "BaseFilter",
  components: { BaseScrollbar },
  data() {
    return {
      sorting: {
        label: 'Last created',
        value: 'ASC',
      },
      brandDetectionOnly: false,
      videoAnalyticOnly: false,
    }
  },
  props: ['showFilter', 'showSorting', 'showType', 'oneColumn', 'filterBrands', 'filterAnalytic'],
  computed: {
    sortingOptions() {
      if (this.filterBrands) {
        return [
          {
            label: 'Exposure, s',
            value: '-exposure_time_sec',
          },
          {
            label: 'Exposure, %',
            value: '-exposure_time_pct',
          },
          {
            label: 'Mean Area, %',
            value: '-mean_area_pct'
          },
          {
            label: 'BIS',
            value: '-bis'
          },
        ]
      }

      if (this.filterAnalytic) {
        return [
          {
            label: 'Length, s',
            value: '-video_duration_sec',
          },
          {
            label: 'In order',
            value: 'start_time',
          },
          {
            label: 'In reverse',
            value: '-start_time'
          }
        ]
      }
      return [
        {
          label: 'Newest first',
          value: 'desc',
        },
        {
          label: 'Oldest first',
          value: 'asc',
        }
      ]
    },
  },
  watch: {
    sorting(v) {
      this.$emit('sort', v)
    },
    brandDetectionOnly(v) {
      this.$emit('brandDetectionOnly', v)
    },
    videoAnalyticOnly(v) {
      this.$emit('VideoAnalyticOnly', v)
    },
  }
}
</script>

<style scoped lang="scss">
  /deep/

  .el-checkbox {
    &-group {
      display: flex;
      flex-direction: column;
    }
    .el-checkbox__input + .el-checkbox__label {
      color: #00204D;
    }
    &.is-checked {
      .el-checkbox__inner {
        width: 17px !important;
        height: 17px !important;
        display: flex;
        align-items: center;
        justify-content: center;
        &::after {
          left: 7px;
          position: absolute;
          top: 3px;
        }
      }
    }
    &__inner {
      width: 17px !important;
      height: 17px !important;
      border: none;
      background: #F2F4F6;
    }
  }
  .filter {
    /deep/
    .el-select, .el-input__inner {
      height: 28px;
      color: red !important;
      input {
        height: 28px;
      }
      .el-input__suffix {
        top: 30%;
      }
    }

    /deep/
    .el-input.is-focus {
      .el-input__suffix {
        top: -7px;
      }


    }

    /deep/
    input, .el-input__inner {
      color: #00204D !important;
    }
  }
</style>
